const NOOP = () => {};
const registerEventHandler = NOOP;
const unregisterEventHandler = NOOP;
export { registerEventHandler, unregisterEventHandler };
//# sourceMappingURL=event-handler.web.js.map